import { useEffect, useState } from 'react'
import { useUserStore } from '../../store/userStore';
import { swalErrorAlert } from '../../utils/swal/swal';
import { useLocation } from 'react-router-dom';
import { getSchoolRecordIsShowApi, getSchoolRecordListApi } from '../../api/schoolRecord';
import { SearchForm } from '../admin/common/SearchForm';

/* Components */
import NoSearchResult from '../../components/common/NoSearchResult';
import NoList from '../../components/common/NoList';
import SchoolRecordVer2List from '../../components/schoolRecord/form/user/SchoolRecordVer2List';

const SchoolRecordListPage = () => {
    /* zustand */
    const { userInfo } = useUserStore(state => state)

    /* 검색기능 */
    const location = useLocation();
    const pathname = location.pathname
    const params = new URLSearchParams(location.search);
    const searchTerm = params.get('search')

    const [isShow, setIsShow] = useState(false)
    const [schoolRecordList, setSchoolRecordList] = useState([])

    useEffect(() => {
        const userId = userInfo?.user_id
        getIsShow(userId)
    }, [userInfo])

    useEffect(() => {
        const userId = userInfo?.user_id
        if (!userId || !isShow) {
            setSchoolRecordList([])
        }
        else {
            getSchoolRecordList(userId, searchTerm)
        }
    }, [isShow, userInfo, searchTerm])


    const getIsShow = async (userId) => {
        try {
            const response = await getSchoolRecordIsShowApi(userId)
            console.log(response);
            

            if (response.data.code === 200) {
                const isShow = response.data.resData ? true : false
                setIsShow(isShow)
            }
            else {
                throw new Error("get isShow Data failed");
            }

        } catch (error) {
            console.log(error);
            setIsShow(false)
        }
    }

    const getSchoolRecordList = async (userId, searchTerm) => {
        if (!userId) return

        try {
            const response = await getSchoolRecordListApi(userId, searchTerm)

            if (response.data?.code === 200) {
                const list = response.data?.resData
                setSchoolRecordList(list)
                return

            } else {
                throw new Error("생활기록부 조회 에러: api 400 실패");
            }
        } catch (error) {
            console.log(error);
            swalErrorAlert('생활기록부 조회 에러', '생활기록부 데이터를 조회하는 도중에 에러가 발생하였습니다.', 'error', '확인')
            return
        }
    }

    return (
        <>
            <div className='mb-3'>
                <div className='d-flex justify-content-between'>
                    <h3 className='h3'>생활기록부 리스트</h3>

                    <div>
                        <SearchForm pathname={pathname} searchTerm={searchTerm} placeHolder={'제목을 검색해 주세요.'} />
                    </div>
                </div>
            </div>

            {isShow ?
                (schoolRecordList.length === 0 ?
                    (searchTerm ?
                        <NoSearchResult searchTerm={searchTerm} />
                        : <NoList />
                    )
                    : <SchoolRecordVer2List list={schoolRecordList} />
                )
                : <IsShowFalse />
            }
        </>
    )
}

const IsShowFalse = () => {
    return (
        <div>생활기록부 열람 기간이 아닙니다.</div>
    )
}

export default SchoolRecordListPage